import { ObjectTypes } from "../enums";

export class s {
    static tolerance = 20;
    static tripLen = 2000;
    static aspectRatio = 1;
    static textOffset = 6;
    static canvasWidth: number | null = null;
    static canvasHeight: number | null = null;
    static webglContext: WebGLRenderingContext | null = null;
    static textContext: CanvasRenderingContext2D | null = null;
    static tooltipBottomOffset = 25;

    static guideColor = [1, 0, 1, 0.75];

    static blockColor = [.1, .1, .1, 1];
    static blockThickness = 2;
    static connectionPointRadius = 7.5;
    static connectionPointColor = [.5, .5, 1, 1];
    static connectionPointThickness = 1;

    // ** elbow point **
    static elbowPointRadius = 5;
    static elbowPointColor = [0.996, 0.918, 0, 1];

    // ** tee color **
    static teeColor = [0.5, 0, 0.5, 1];
    static teeType = ObjectTypes.simpleTee;

    // ** elbow color **
    static elbowColor = [.5, 0, .5, 1];
    static elbowType = ObjectTypes.simpleElbow;


    static roundTolerance = 1 ** 10 ^ -10; // знаков после запятой

    // эквивалентная шероховатость
    static eqRoughness = 0.1;

    // температура воздуха для расчёта потерь давления в воздуховодах
    static airTemperature = 20;
    static format: string | number[];

    static setCanvasSize(width: number, height: number) {
        this.canvasWidth = width;
        this.canvasHeight = height;
    }
    static setWebglContext(gl: WebGLRenderingContext) {
        this.webglContext = gl;
    }
    static setTextContext(context: CanvasRenderingContext2D) {
        this.textContext = context;
    }
}